module.exports = __webpack_public_path__ + "img/house_09.08e6b067.jpg";